export const removeElementById = (id: string) => document.getElementById(id)?.remove();
